<script setup lang="ts">
import type { IMenuItem } from "@/components/legacy/Menu/menu.interface"
import { computed } from "vue"
import { AppLink, Icon } from "@/components/ui"

const props = defineProps<{
  item: IMenuItem
}>()

const emit = defineEmits<{
  (e: "itemClick", item: IMenuItem): void
}>()

function onItemClick(item: IMenuItem) {
  emit("itemClick", item)
  if (item.onClick)
    item.onClick()
}

const componentType = computed(() => {
  return props.item.to ? AppLink : props.item.href ? "a" : "button"
})
</script>

<template>
  <component
    :is="componentType" :key="item.key" :href="item.href" :to="item.to"
    class="flex items-center text-left gap-2 menu-item py-2 px-4 whitespace-nowrap transition ease-in w-full rounded-xl cursor-pointer"
    :class="item.variant ? `menu-item_${item.variant}` : ''"
    :data-test="`menu-item-${item.key}`"
    @click="() => onItemClick(item)"
  >
    <Icon v-if="item.icon" :icon="item.icon" class="p-0 -ml-[5px]" size="sm" />
    {{ item.label }}
  </component>
</template>

<style lang="postcss" scoped>
@reference "../../../assets/styles.css";

.menu-item:hover,
.menu-item:focus,
.menu-item_highlighted {
  background-color: #e9ecef;

  @apply text-primary;
}

.menu-item_danger {
  @apply text-danger;
}

.menu-item_danger:hover,
.menu-item_danger:focus {
  @apply bg-danger text-white;
}
</style>
